// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pagination-container[data-v-72233bcd] {\r\n  background: #fff;\r\n  padding: 16px;\r\n  border-radius: 2px;\r\n  -webkit-box-shadow: 0 2px 5px 0 rgba(164, 173, 186, 0.25);\r\n          box-shadow: 0 2px 5px 0 rgba(164, 173, 186, 0.25);\n}\n.pagination-container.hidden[data-v-72233bcd] {\r\n  display: none;\n}\r\n", ""]);
// Exports
module.exports = exports;
